import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  public loadingStatus$ = new EventEmitter();

  constructor() { }

  public active(): void {
    this.loadingStatus$.emit(true);
  }
  
  public disactive(): void {
    this.loadingStatus$.emit(false);
  }
}
